import api from '../api/axiosInstance';
import { PipelineItem, PipelineStatus } from '../const/PipelineTypes';

export const workflowManualActionsService = {
  sendHandleSelectiveOnboardingAction: async (pipeline: PipelineItem, mode: 'approve' | 'reject'): Promise<string> => {
    const endpoint =
      mode === 'approve'
        ? '/api/workflows-onboarding/selective-onboarding/approve'
        : '/api/workflows-onboarding/selective-onboarding/reject';
    return api
      .put(
        endpoint,
        {
          ticketId: pipeline.TicketId,
          automationFlowId: pipeline.automationFlow?.id
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  },
  sendPromoteArtifacts: async (ticketId: string, automationFlowId: string): Promise<string> => {
    return api
      .put(
        `/api/workflows-actions/promote`,
        { ticketId: ticketId, automationFlowId: automationFlowId },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  },
  sendCreateWorkflowStep: async (pipeline: PipelineItem, stage: string, step: string, status: PipelineStatus): Promise<string> => {
    const data = {
      workflow: {
        TicketId: pipeline.TicketId,
        Stage: stage,
        Step: step,
        timestamp: '',
        Environment: pipeline.environment,
        Status: status,
        automation_flow_id: pipeline?.automationFlow?.id
      }
    };
    return api.put(`/api/workflows/steps`, data).then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  },
  sendAutomationTestExecution: async (pipeline: PipelineItem): Promise<string> => {
    const data = {
      ticketId: pipeline.TicketId,
      automationFlowId: pipeline.automationFlow?.id,
      productLine: pipeline.metadata.ProductLine,
      productNumber: (pipeline.metadata.Products || []).map((product: { RState: string; ProductNumber: string }) => product.ProductNumber),
      productVersion: pipeline.metadata.Header
    };
    return api
      .post(`/api/test-collections/automation`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  },
  sendDeployRAppManually: async (pipeline: PipelineItem): Promise<string> => {
    const data = {
      workflowId: pipeline.TicketId,
      automationFlowId: pipeline.automationFlow?.id
    };
    return api
      .put(`/api/workflows-actions/deploy-rapp`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  },
  sendWorkflowAction: async (pipeline: PipelineItem, endpoint: string): Promise<string> => {
    const data = {
      workflowId: pipeline.TicketId,
      automationFlowId: pipeline.automationFlow?.id
    };
    return api
      .put(`/api/workflows-actions/${endpoint}`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => (res.status >= 200 && res.status < 300 ? 'ok' : 'nok'));
  }
};
